module.exports = __webpack_public_path__ + "static/media/citadel.2603663d.png";